import { render, staticRenderFns } from "./game-form-page.vue?vue&type=template&id=5c1a6885&"
import script from "./game-form-page.vue?vue&type=script&lang=js&"
export * from "./game-form-page.vue?vue&type=script&lang=js&"
import style0 from "./game-form-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports